import { TFunction } from "i18next";

export const t = (msg: string, _options?: { [key: string]: unknown }): string => {
  return msg;
};

/**
 * this function translates error messages directly from the backend into user friendly messages
 * @param msg error message
 */
export const errorTranslation = (msg: string, translate: TFunction): string => {
  const rules: Array<{ match: string; key: string }> = [
    { key: "CUSTOMER_NOT_FOUND", match: "Customer not found" },
    { key: "CUSTOMER_EMAIL_NOT_MATCH", match: "Customer email not match" },
    { key: "ISSUE_WITH_ACCOUNT_ID_MESSAGE", match: "AMS access code not unique" },
  ];

  const matchedRule = rules.find(({ match }) => msg.includes(match));
  return matchedRule ? translate(matchedRule.key) : msg;
};
